import { API_CANAL } from "@/utils/consts";
import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";

export const useBeneficiaryService = () => {
  const useGetPerson = async (request) => {
    const response = await HTTP_REQUEST.postWitchTrace(
      url.newObtenerTercero,
      request,
      "APIS_VCT",
      API_CANAL
    );
    return response;
  };

  const useGetRelationship = async () => {
    const request = {
      atributo: "parentesco",
    };
    const response = await HTTP_REQUEST.postWitchTrace(
      url.getRelationship,
      request,
      "APIS_VCT",
      API_CANAL
    );
    return response;
  };

  return {
    useGetPerson,
    useGetRelationship,
  };
};
